import { useEffect } from 'react';
import { useAnalyticsEvents } from '../../../../../common/analytics/generated/use-analytics-events';
var AIEventErrorViewed = function AIEventErrorViewed(_ref) {
  var reason = _ref.reason;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.viewed.aiSummary', {
      reason: reason
    });
  }, [fireEvent, reason]);
  return null;
};
export default AIEventErrorViewed;